





































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import rtStep from "@/components/couponcancel/rtStep.vue";
import { Toast } from "vant";

const couponModule = namespace("coupon");

@Component({
  components: {}
})
export default class Search extends Vue {
  @couponModule.State("effectiveCouponEntity") couponDetail!: any;
  value: any = "";

  mounted() {
    (this as any).$wechartfunc();
    this.setActive();
  }

  setActive() {
    this.$store.commit("coupon/setcouponSearchStep", 1);
  }

  async handleSearchClick() {
    this.$store.commit("coupon/setEffectiveQrCode", this.value);
    const { error, success } = await this.$store.dispatch(
      "coupon/getEffectiveCouponEntity",
      0
    );
    if (success) {
      this.$router.push({
        path: `/couponVerification/searchDetail`,
        query: {
          sancode: this.value
        }
      });
    } else {
      Toast(error.msg);
    }
  }
  async handleScanCodeClick() {
    // const wx:any = (window as any).wx;
    // const _this:any = this;
    // wx.scanQRCode({
    //     needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
    //     scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
    //     success: function (res:any) {
    //         _this.$router.push({ path: `/couponVerification/searchDetail`, query: {
    //             sancode: res.resultStr
    //         }});
    //         // return res.resultStr; // 当needResult 为 1 时，扫码返回的结果
    //     }
    // });
    const scanQRCode: any = await (this as any).$wechartfunc("scanQRCode");
    if (scanQRCode) {
      console.log(scanQRCode);
      this.$router.push({
        path: `/couponVerification/searchDetail`,
        query: {
          sancode: scanQRCode
        }
      });
    }
    /** TODO  小程序扫码地址 */
    // const wx = window.wx;
    // wx.miniProgram.navigateTo({
    //     url: ''
    // });
  }
}
